import {
  Card,
  CardContent,
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  useTheme,
} from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import AuturaTextField from 'components/inputs/AuturaTextField';
import { AppContext } from 'context/appContext';
import { useContext } from 'react';

interface LoginPreviewProps {
  logoUrl: string;
  logoPadding: number;
}

const LoginPreview = ({ logoUrl, logoPadding }: LoginPreviewProps) => {
  const { t } = useTranslation();
  const { state } = useContext(AppContext);
  const theme = useTheme();

  return (
    <Card
      raised
      sx={{
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: {
          xs: '100dvh',
          sm: `calc(100dvh - 48px)`,
        },
      }}
    >
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'row'}
        maxHeight={`calc(100dvh - 448px)`}
        sx={{
          objectFit: 'contain',
        }}
        width={'100%'}
      >
        <img
          src={logoUrl}
          alt='logo'
          style={{
            width: '100%',
            maxHeight: `calc(100dvh - 448px)`,
            maxWidth: `calc(100dvh - 448px)`,
            padding: `${logoPadding}px`,
          }}
        />
      </Box>
      <CardContent
        sx={{
          px: {
            xs: 2,
            sm: 12,
          },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 416,
        }}
      >
        <Stack
          direction={'column'}
          justifyContent={'space-between'}
          alignItems={'center'}
          gap={1}
          sx={{ width: '100%', height: 349 }}
        >
          <Typography variant='h4'>{t('signin')}</Typography>
          <Box width={'100%'}>
            <AuturaTextField
              label={t('email')}
              fullWidth
              name='preview-email'
              readonly
              autoComplete='off'
              value={state.user?.email || ''}
            />
            <FormControlLabel
              sx={{ pl: 2, mt: -0.5 }}
              control={<Checkbox checked size={'small'} tabIndex={-1} />}
              label={
                <Typography variant='caption'>{t('rememberMe')}</Typography>
              }
            />
          </Box>
          <Box width={'100%'}>
            <AuturaTextField
              type='text'
              value={'••••••••••••'}
              name='preview-password'
              readonly
              autoComplete='off'
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    edge='end'
                    tabIndex={-1}
                  >
                    {<Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label={t('password')}
            />
            <Button onClick={() => {}} variant='text'>
              <Typography
                variant='caption'
                color={theme.palette.info.main}
                sx={{ pl: 2 }}
              >
                {t('forgotPassword') + '?'}
              </Typography>
            </Button>
          </Box>
          <Box py={3} width={'100%'} height={98}>
            <Button
              centerRipple
              fullWidth
              color={'primary'}
              type='submit'
              variant='contained'
              sx={{ height: 50 }}
              disabled
            >
              {t('signin')}
            </Button>
          </Box>
        </Stack>
        <Box
          height={67}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          width={'100%'}
        ></Box>
      </CardContent>
    </Card>
  );
};

export default LoginPreview;
